import {
  Typography,
  Box,
  Card,
  CardContent,
  Switch,
  FormControlLabel,
  Divider,
  Button,
} from "@mui/material";

/**
 * Settings page demonstrating form controls and layout.
 */
export function SettingsPage() {
  return (
    <Box>
      <Typography variant="h6" gutterBottom>
        Settings
      </Typography>
      <Typography variant="body2" color="text.secondary" paragraph>
        Configure your application preferences
      </Typography>

      <Card sx={{ mb: 3 }}>
        <CardContent>
          <Typography variant="h6" gutterBottom>
            Notifications
          </Typography>
          <Box sx={{ display: "flex", flexDirection: "column", gap: 2 }}>
            <FormControlLabel
              control={<Switch defaultChecked disabled />}
              label="Email notifications"
            />
            <FormControlLabel
              control={<Switch defaultChecked disabled />}
              label="Push notifications"
            />
            <FormControlLabel control={<Switch disabled />} label="SMS notifications" />
          </Box>
        </CardContent>
      </Card>

      <Card sx={{ mb: 3 }}>
        <CardContent>
          <Typography variant="h6" gutterBottom>
            Display
          </Typography>
          <Box sx={{ display: "flex", flexDirection: "column", gap: 2 }}>
            <FormControlLabel control={<Switch defaultChecked disabled />} label="Compact mode" />
            <FormControlLabel control={<Switch disabled />} label="Show tooltips" />
            <FormControlLabel control={<Switch defaultChecked disabled />} label="Animations" />
          </Box>
        </CardContent>
      </Card>

      <Card>
        <CardContent>
          <Typography variant="h6" gutterBottom>
            Danger Zone
          </Typography>
          <Divider sx={{ my: 2 }} />
          <Typography variant="body2" color="text.secondary" paragraph>
            Permanently delete your account and all associated data
          </Typography>
          <Button variant="outlined" color="error" disabled>
            Delete Account
          </Button>
        </CardContent>
      </Card>
    </Box>
  );
}
